import { IconWithHover } from '@/components/IconWithHover';
import DeleteModal from '@/components/Modals/DeleteModal';
import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import Trash from '@/images/Trash.svg';
import { useProjectIdb } from '@/pages/AdvancedEditor/hooks/polotno-store/store-init/useProjectIdb';
import { newProjectId } from '@/pages/AdvancedEditor/types';
import { useAnalytics } from '@/services/analytics';
import { useBulkDeleteFromLibraryMutation, useSelectedVideos } from '@/state/video-library/videoLibrary';
import theme from '@/theme';
import styled from '@emotion/styled';
import { tooltipClasses } from '@mui/material/Tooltip';
import { useState } from 'react';

const StyledToolTip = styled(CustomTooltip)`
    & .${tooltipClasses.tooltip} {
        background-color: ${theme.colors.secondary.main};
    }
`;

export const DeleteAction = () => {
    const { selected, reset } = useSelectedVideos();
    const mixpanel = useAnalytics();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const { mutate: deleteItems, isLoading: isDeleting } = useBulkDeleteFromLibraryMutation();
    const { clearIdbDraft } = useProjectIdb();
    const onItemsDelete = async () => {
        if (!selected.size) {
            return;
        }

        mixpanel?.track('bulk-delete-projects', {
            event: 'click',
            from: 'library',
        });

        if (selected.has(newProjectId)) {
            await clearIdbDraft();
        }

        deleteItems([...selected.keys()]);
        reset();
    };

    return (
        <>
            <StyledToolTip title="Delete videos">
                <IconWithHover src={Trash} size="24px" onClick={() => setShowDeleteModal(true)} />
            </StyledToolTip>

            <DeleteModal
                itemType="video"
                mode="square"
                open={showDeleteModal}
                isLoading={isDeleting}
                onDelete={onItemsDelete}
                onClose={() => setShowDeleteModal(false)}
                text={{
                    title: 'Confirm delete',
                    content: `Are you sure you want to delete ${selected.size} videos from your library? This action cannot be undone.`,
                    cta: 'Delete videos',
                }}
            />
        </>
    );
};
